import { useLocation } from 'react-router-dom'

import { useWakeLock } from '@/hooks/useWakeLock'
import { resolvePathname } from '@/lib/analytics/pageContext'

// Route-level wiring, mounted once at the router root (beside RouteAnalytics). Holds a
// Screen Wake Lock for any route whose definition opts in with `keepScreenAwake` (see
// routes/paths.ts) — currently the roleplay routes, so the screen stays awake through the
// active call AND the feedback-generation phase that follows on the same route. The lock
// is released automatically the moment navigation lands on a route without the flag.
// Renders nothing.
export function ScreenWakeLockManager() {
  const { pathname } = useLocation()
  const { keepScreenAwake } = resolvePathname(pathname)
  useWakeLock(keepScreenAwake)
  return null
}
